import * as React from 'react';
import styled from 'styled-components';

const List = styled.ul`
  display: flex;
  justify-content: flex-start;
  padding: 0;
  list-style: none;
`;

const Item = styled.li`
  margin-right: 2rem;
  width: 1.75rem;
`;

const Twitter = () => (
  <svg viewBox="0 0 112.197 112.197" width="40px">
    <circle cx="56.099" cy="56.098" r="56.098" fill="#55ACEE" />
    <path
      d="M90.46 40.316c-2.403 1.066-4.99 1.787-7.7 2.11 2.768-1.66 4.893-4.285 5.896-7.418-2.59 1.537-5.462 2.652-8.515 3.253-2.445-2.604-5.93-4.232-9.79-4.232-7.403 0-13.408 6.005-13.408 13.41 0 1.05.12 2.073.35 3.055-11.145-.56-21.026-5.897-27.64-14.012-1.154 1.98-1.816 4.286-1.816 6.743 0 4.65 2.37 8.757 5.965 11.16-2.196-.068-4.265-.67-6.072-1.678v.17c0 6.497 4.623 11.916 10.756 13.147-1.124.308-2.31.47-3.532.47-.866 0-1.705-.082-2.523-.238 1.705 5.326 6.656 9.203 12.525 9.312-4.59 3.597-10.37 5.74-16.655 5.74-1.08 0-2.15-.063-3.197-.188 5.93 3.806 12.98 6.025 20.553 6.025 24.664 0 38.152-20.432 38.152-38.153 0-.58-.013-1.16-.04-1.734 2.623-1.89 4.896-4.25 6.693-6.94z"
      fill="#F1F2F2"
    />
  </svg>
);

const Linkedin = () => (
  <svg viewBox="0 0 112.196 112.196" width="40px">
    <circle cx="56.098" cy="56.097" r="56.098" fill="#007AB9" />
    <path
      d="M89.616 60.61v23.13h-13.41V62.16c0-5.417-1.935-9.117-6.79-9.117-3.705 0-5.906 2.49-6.878 4.903-.353.862-.444 2.06-.444 3.268v22.524h-13.41s.18-36.546 0-40.33h13.41v5.716c-.026.045-.064.09-.088.132h.09v-.132c1.78-2.742 4.96-6.662 12.084-6.662 8.822 0 15.436 5.764 15.436 18.15zm-54.96-36.64c-4.587 0-7.588 3.01-7.588 6.966 0 3.872 2.914 6.97 7.412 6.97h.087c4.677 0 7.585-3.098 7.585-6.97-.09-3.956-2.908-6.967-7.496-6.967zm-6.79 59.77H41.27V43.41H27.865v40.33z"
      fill="#F1F2F2"
    />
  </svg>
);

const Github = () => (
  <svg viewBox="0 0 438.549 438.549" width="40px">
    <path d="M409.132 114.573c-19.608-33.596-46.205-60.194-79.798-79.8C295.736 15.166 259.057 5.365 219.27 5.365c-39.78 0-76.47 9.804-110.062 29.408-33.596 19.605-60.192 46.204-79.8 79.8C9.803 148.168 0 184.853 0 224.63c0 47.78 13.94 90.745 41.827 128.906 27.884 38.164 63.906 64.572 108.063 79.227 5.14.954 8.945.283 11.42-1.996 2.474-2.282 3.71-5.14 3.71-8.562 0-.57-.05-5.708-.144-15.417-.098-9.71-.144-18.18-.144-25.406l-6.567 1.136c-4.187.767-9.47 1.092-15.846 1-6.375-.09-12.992-.757-19.843-2-6.854-1.23-13.23-4.085-19.13-8.558-5.898-4.473-10.085-10.328-12.56-17.556l-2.855-6.57c-1.903-4.374-4.9-9.233-8.992-14.56-4.093-5.33-8.232-8.944-12.42-10.847l-1.998-1.43c-1.332-.952-2.568-2.1-3.71-3.43-1.143-1.33-1.998-2.663-2.57-3.997-.57-1.335-.097-2.43 1.428-3.29 1.525-.858 4.28-1.275 8.28-1.275l5.708.853c3.807.763 8.516 3.042 14.133 6.85 5.615 3.807 10.23 8.755 13.847 14.843 4.38 7.807 9.657 13.755 15.846 17.848 6.184 4.093 12.42 6.136 18.7 6.136 6.28 0 11.703-.476 16.273-1.423 4.565-.95 8.848-2.382 12.847-4.284 1.713-12.758 6.377-22.56 13.988-29.41-10.847-1.14-20.6-2.857-29.263-5.14-8.658-2.286-17.605-5.996-26.835-11.14-9.235-5.137-16.896-11.516-22.985-19.126-6.09-7.614-11.088-17.61-14.987-29.98-3.9-12.373-5.852-26.647-5.852-42.825 0-23.035 7.52-42.637 22.557-58.817-7.044-17.318-6.38-36.732 1.997-58.24 5.52-1.715 13.706-.428 24.554 3.853 10.85 4.284 18.794 7.953 23.84 10.995 5.046 3.04 9.09 5.618 12.135 7.708 17.706-4.947 35.977-7.42 54.82-7.42s37.116 2.473 54.822 7.42l10.85-6.85c7.418-4.57 16.18-8.757 26.26-12.564 10.09-3.806 17.803-4.854 23.135-3.14 8.562 21.51 9.325 40.923 2.28 58.24 15.035 16.18 22.558 35.788 22.558 58.818 0 16.178-1.958 30.497-5.853 42.966-3.9 12.47-8.94 22.457-15.125 29.98-6.19 7.52-13.9 13.85-23.13 18.985-9.233 5.14-18.183 8.85-26.84 11.135-8.663 2.286-18.416 4.004-29.264 5.146 9.894 8.563 14.842 22.078 14.842 40.54v60.237c0 3.422 1.19 6.28 3.572 8.562 2.38 2.278 6.136 2.95 11.276 1.994 44.163-14.653 80.185-41.062 108.068-79.226 27.88-38.16 41.826-81.126 41.826-128.906-.01-39.77-9.818-76.454-29.414-110.05z" />
  </svg>
);

const SocialMedias = () => (
  <List>
    <Item>
      <a href="https://twitter.com/emilien_muraton/">
        <Twitter />
      </a>
    </Item>
    <Item>
      <a href="https://www.linkedin.com/in/emilien-muraton-92b334a1/">
        <Linkedin />
      </a>
    </Item>
    <Item>
      <a href="https://github.com/emuraton/">
        <Github />
      </a>
    </Item>
  </List>
);

export default SocialMedias;
